import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommentsService } from '../service/comments.service';
import { getFunctions, httpsCallable } from '@angular/fire/functions';
import { Functions } from "@angular/fire/functions";
import { SettingsService } from '../service/settings.service';
import { TranslateService } from '@ngx-translate/core';
import { ReportService } from '../service/report.service';
import { getApp } from '@angular/fire/app';

@Component({
    selector: 'app-duplicate-report-template',
    templateUrl: './duplicate-report-template-dialog.component.html',
    styleUrls: ['./duplicate-report-template-dialog.component.css'],
    standalone: false
})
export class DuplicateReportTemplateDialogComponent implements OnInit{

  duplicateContentForm!:FormGroup
  selectedReportTemplateId:any
  reportToDuplicateTitle:any
  // private readonly functions: Functions;

  constructor(
    public dialogRef: MatDialogRef<DuplicateReportTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private settingService: SettingsService,
    private fb: FormBuilder,
    private functions: Functions,
    private translate:TranslateService,
    private commentService: CommentsService,
    private translateService: TranslateService,
    private reportService: ReportService
  ){
    dialogRef.disableClose = true;
    // const functions = getFunctions(getApp(), 'europe-west1');
    // this.functions = functions;
  }

  ngOnInit(): void {
    this.selectedReportTemplateId = this.data.reportTemplateId
    this.reportToDuplicateTitle = this.data.oldTitle

    this.duplicateContentForm = this.fb.group({
      displayName:[,Validators.required]
    })
  }


  cancelDuplication(){
    this.dialogRef.close([false]);
  }

  duplicateReportTemplate(){
    if(this.duplicateContentForm.value.displayName && this.selectedReportTemplateId && this.duplicateContentForm.value.displayName){
      this.commentService.progressSpin.emit(true)
      
      const data = {
        contextId: this.settingService.contextId$,
        reportTemplateId: this.selectedReportTemplateId,
        displayName: this.duplicateContentForm.value.displayName
      }


      try{
        const createExperience = httpsCallable(this.functions, 'admin-duplicateReportTemplate');

        createExperience(data ).then((result) => {
          const data = result.data;
          const id = data['reportTemplateId']
          this.commentService.progressSpin.emit(false)
          this.dialogRef.close([true,id]);
        })
        .catch((error) => {
          this.commentService.progressSpin.emit(false)
          console.log(error)
          const message = this.translateService.instant("SnackBarConstants.DUPLICATION_FAILED")
          this.commentService.addSnackBar.emit(message)
          this.commentService.addSnackBar.emit(error)
        });
      }catch(error){

        this.commentService.progressSpin.emit(false)
        console.log(error)
        const message = this.translate.instant("SnackBarConstants.DUPLICATION_FAILED")
      }
    } 
  } 
}